import { NgModule } from '@angular/core';
import { SafePipe } from './safe.pipe/safe.pipe';
import { DatePipe, DateTimePipe, FileSizePipe } from './data.formatters';
import { FilterPipe } from './filter.pipe';
import { SortByPipe } from './sortby.pipe';

@NgModule({
  imports: [],
  declarations: [
    SafePipe,
    DatePipe,
    DateTimePipe,
    FileSizePipe,
    FilterPipe,
    SortByPipe
  ],
  exports: [
    SafePipe,
    DatePipe,
    DateTimePipe,
    FileSizePipe,
    FilterPipe,
    SortByPipe
  ],
})

export class PipeModule {

  static forRoot() {
    return {
      ngModule: PipeModule,
      providers: [],
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/common/pipe.module.ts